module.exports = __webpack_public_path__ + "img/icons/new/publish-rp-d0e615b1ea1a03ce020842c93c3f34d7.svg";